// frontend/src/utils/planFeatures.ts
// Kullanıcı ve veli odaklı, net, açıklayıcı ve ikna edici plan özellikleri

export interface PlanFeatureItem {
  id: string;
  title: string;
  desc?: string;
  highlight?: boolean;
}

// Bireysel özellik anahtarlarının detaylı başlık ve kullanıcı odaklı açıklamaları
export const FEATURE_CATALOG: Record<string, { title: string; desc: string }> = {
  // ── Ders ve Müfredat Erişimi ──
  'course.access': {
    title: 'Temel Kodlama & Algoritma Dersleri',
    desc: 'Python, Scratch, Mantık ve Fen modülleri ile sağlam bir temel inşa eder.',
  },
  'course.premium': {
    title: 'Tüm Premium Dersler & İleri Müfredat',
    desc: 'Web geliştirme, yapay zeka ve veri bilimi dahil tüm branşlara sınırsız erişim.',
  },
  'lesson.preview': {
    title: 'Ders Önizleme Hakları',
    desc: 'Yeni eklenen dersleri ve popüler içerikleri önceden deneyimleme olanağı.',
  },
  'lesson.premium': {
    title: 'Sınırsız Tüm Ders İçerikleri',
    desc: 'Tüm video, interaktif alıştırma ve uygulamalı derslere kısıtlamasız erişim.',
  },

  // ── CinAli & Yapay Zeka Özellikleri ──
  'ai.chat': {
    title: 'CinAli AI Öğretmen (Günde 10 Soru)',
    desc: 'Yapay zeka öğretmenine takıldığı yerlerde temel sorular sorup yardım alma hakkı.',
  },
  'ai.chat_30': {
    title: 'CinAli AI Desteği (Günde 30 Soru)',
    desc: 'Öğrencinin takıldığı yerlerde anında ipucu veren ve düşündüren akıllı mentorluk.',
  },
  'ai.mentor': {
    title: 'Sınırsız CinAli YZ Mentorluk',
    desc: '7/24 kesintisiz soru sorma, anında açıklama ve adım adım kod kılavuzluğu.',
  },
  'ai.code_review': {
    title: 'Yapay Zeka Kod Analizi & İpuçları',
    desc: 'Öğrencinin yazdığı kodları inceleyip hataları anında bulur ve çözümü öğretir.',
  },
  'ai.code_fix': {
    title: 'Akıllı Kod Hata Düzeltme',
    desc: 'Sentaks ve mantık hatalarında nerede hata yapıldığını interaktif açıklar.',
  },
  'ai.project_generator': {
    title: 'YZ Proje & Mini Oyun Üretici',
    desc: 'Öğrencinin ilgi alanına göre kişiselleştirilmiş yeni kodlama projeleri tasarlar.',
  },
  'ai.quiz_generator': {
    title: 'Kişiselleştirilmiş YZ Sınav & Quizler',
    desc: 'Öğrencinin eksik olduğu konulara göre anlık pekiştirme testleri hazırlar.',
  },
  'ai.learning_plan': {
    title: 'Kişiye Özel YZ Öğrenme Rotası',
    desc: 'Öğrencinin öğrenme hızına ve ilgi alanlarına göre dinamik müfredat planlar.',
  },

  // ── Motivasyon, Oyunlaştırma & Başarı ──
  'certificate.generate': {
    title: 'Doğrulanabilir Başarı Sertifikaları',
    desc: 'Bitirilen her modül için karekodlu, resmi ve portfolyoya eklenebilir sertifika.',
  },
  'hackathon.join': {
    title: 'Ödüllü Hackathon & Turnuva Katılımı',
    desc: 'Türkiye genelindeki eğlenceli kodlama yarışmalarında yeteneklerini sergileme fırsatı.',
  },
  'adventure.mode': {
    title: 'Adventure Mode (Macera Haritası)',
    desc: 'Oyunlaştırılmış ada haritasında görevleri çözerek seviye atlama heyecanı.',
  },
  'gamification.rewards': {
    title: 'Oyunlaştırma, Rozetler & XP Puanları',
    desc: 'Her kod satırında kazanılan puanlar, avatar aksesuarları ve liderlik tablosu.',
  },
  'challenge.premium': {
    title: 'Haftalık Özel Meydan Okumalar',
    desc: 'Öğrenmeyi pekiştiren eğlenceli haftalık kodlama ve mantık görevleri.',
  },

  // ── Veli & Ebeveyn Odaklı Özellikler ──
  'parent.report': {
    title: 'Haftalık Yapay Zeka Veli Raporu',
    desc: 'Çocuğunuzun ders ilerlemesini, kavrama hızını ve odaklandığı konuları analiz eden haftalık özet.',
  },
  'parent.progress_tracking': {
    title: 'Anlık İlerleme & Ekran Süresi Takibi',
    desc: 'Hangi modülde kaç dakika çalıştığını ve tamamladığı bölümleri canlı izleyin.',
  },
  'parent.weakness_alert': {
    title: 'Öğrenme Boşluğu & Güçlü Yön Tespiti',
    desc: 'Takıldığı veya zorlandığı noktaları tespit edip ebeveyne özel gelişim önerileri sunar.',
  },
  'parent.multi_child': {
    title: '2 Çocuğa Kadar Tek Panelden Yönetim',
    desc: 'Tüm çocuklarınızın kodlama serüvenini tek bir veli hesabından kolayca takip edin.',
  },
  'parent.safe_zone': {
    title: '%100 Güvenli & Pedagojik Alan',
    desc: 'Reklamsız, dış bağlantılara kapalı ve uzmanlarca denetlenen güvenli öğrenme ortamı.',
  },

  // ── Okul & Kurumsal Özellikler ──
  'school.dashboard': {
    title: 'Kurumsal Okul & Sınıf Paneli',
    desc: 'Tüm sınıfları tek merkezden yönetme, öğretmen ve öğrenci hesaplarını organize etme.',
  },
  'teacher.panel': {
    title: 'Öğretmen Yönetim & Ödev Modülü',
    desc: 'Müfredata uygun haftalık ödevler tanımlama ve öğrenci teslimlerini takip etme.',
  },
  'student.management': {
    title: 'Gelişmiş Öğrenci Başarı Analitiği',
    desc: 'Sınıf geneli ve bireysel öğrenci performansını grafiklerle anlık izleme.',
  },
  'report.pdf': {
    title: 'Kazanım Analiz Raporları (PDF / Excel)',
    desc: 'Okul ve sınıf bazında detaylı başarı grafiklerini tek tıkla resmi rapor olarak indirme.',
  },
  'report.excel': {
    title: 'Detaylı Excel Veri Çıktısı',
    desc: 'Tüm öğrenci ve sınıf metriklerini kurumsal sistemlerle entegre edebilme.',
  },
};

// Key normalleştirici
function normalizeKey(key: string): string {
  return key.toLowerCase().replace(/[\s_-]+/g, '.').trim();
}

// Plan türüne göre zengin, kullanıcı odaklı varsayılan özellik listesi
export const DEFAULT_TIER_FEATURES: Record<string, PlanFeatureItem[]> = {
  // ── Veli Planı ──
  parent: [
    {
      id: 'parent.report',
      title: 'Haftalık Yapay Zeka Veli Raporu',
      desc: 'Çocuğunuzun ders ilerlemesini, kavrama hızını ve odaklandığı konuları analiz eden haftalık özet.',
      highlight: true,
    },
    {
      id: 'parent.progress_tracking',
      title: 'Anlık İlerleme & Ekran Süresi Takibi',
      desc: 'Hangi modülde kaç dakika çalıştığını ve tamamladığı bölümleri canlı izleyin.',
    },
    {
      id: 'parent.weakness_alert',
      title: 'Öğrenme Boşluğu & Güçlü Yön Tespiti',
      desc: 'Takıldığı veya zorlandığı noktaları tespit edip ebeveyne özel gelişim önerileri sunar.',
    },
    {
      id: 'parent.multi_child',
      title: 'Çoklu Çocuk Yönetimi',
      desc: 'Tüm çocuklarınızın kodlama serüvenini tek bir veli hesabından kolayca takip edin.',
    },
    {
      id: 'parent.safe_zone',
      title: '%100 Güvenli & Pedagojik Alan',
      desc: 'Reklamsız, dış bağlantılara kapalı ve uzmanlarca denetlenen güvenli öğrenme ortamı.',
    },
  ],

  // ── Pro / Standart Plan (Öğrenci) ──
  pro: [
    {
      id: 'course.access',
      title: 'Tüm Kodlama & Mantık Dersleri',
      desc: 'Python, Scratch, Görsel Matematik ve Fen modüllerine sınırsız erişim.',
      highlight: true,
    },
    {
      id: 'ai.chat_30',
      title: 'CinAli YZ Öğretmen (Günde 30 Soru)',
      desc: 'Takıldığı sorularda anında ipucu veren ve adım adım yönlendiren akıllı asistan.',
    },
    {
      id: 'ai.code_review',
      title: 'Gelişmiş Kod Hata Analizi',
      desc: 'Yazdığı kodlardaki mantık ve sözdizimi hatalarını anında bulup öğreten sistem.',
    },
    {
      id: 'gamification.rewards',
      title: 'Oyunlaştırma, Rozetler & XP',
      desc: 'Dersleri tamamladıkça kazanılan puanlar, başarı rozetleri ve eğlenceli seviyeler.',
    },
    {
      id: 'practice.quizzes',
      title: 'İnteraktif Quizler & Alıştırmalar',
      desc: 'Öğrenilen bilgileri pekiştiren eğlenceli testler ve meydan okuma görevleri.',
    },
  ],

  // ── Premium Plan ──
  premium: [
    {
      id: 'ai.mentor',
      title: 'Sınırsız CinAli YZ Mentorluk',
      desc: '7/24 kesintisiz soru sorma, anlık kod analizi ve birebir öğrenme rehberliği.',
      highlight: true,
    },
    {
      id: 'course.premium',
      title: 'Tüm Dersler + İleri Düzey Müfredat',
      desc: 'Yapay zeka, veri bilimi ve ileri Python dahil platformdaki tüm eğitimler açık.',
    },
    {
      id: 'certificate.generate',
      title: 'Doğrulanabilir Başarı Sertifikaları',
      desc: 'Bitirilen her modül için karekodlu, resmi ve portfolyoya eklenebilen sertifika.',
    },
    {
      id: 'ai.project_generator',
      title: 'YZ Proje & Oyun Üretici',
      desc: 'Kendi hayalindeki oyun ve mini uygulamaları yapay zeka yardımıyla tasarlama.',
    },
    {
      id: 'adventure.mode',
      title: 'Adventure Mode & Hackathon Katılımı',
      desc: 'Özel macera haritası ve ödüllü kodlama turnuvalarına öncelikli katılım.',
    },
    {
      id: 'parent.report',
      title: 'Haftalık Veli Gelişim Raporu Dahil',
      desc: 'Veli paneline çocuğunuzun haftalık başarı analizi otomatik olarak aktarılır.',
    },
  ],

  // ── Ücretsiz Plan ──
  free: [
    {
      id: 'course.access',
      title: 'Temel Başlangıç Dersleri',
      desc: 'Scratch ve temel algoritma modülleriyle kodlama dünyasına ilk adım.',
    },
    {
      id: 'ai.chat',
      title: 'CinAli AI Deneme Hakkı (Günde 10 Soru)',
      desc: 'Yapay zeka öğretmenimizle tanışma ve temel sorular sorma imkanı.',
    },
    {
      id: 'game.basic',
      title: 'Temel Mini Oyunlar',
      desc: 'Mantıksal düşünmeyi geliştiren eğlenceli başlangıç seviyesi bulmacaları.',
    },
    {
      id: 'safe.environment',
      title: 'Güvenli & Reklamsız Deneyim',
      desc: 'Kredi kartı gerekmeden platformu güvenle keşfetme fırsatı.',
    },
  ],

  // ── Okul / Kurumsal Plan ──
  school: [
    {
      id: 'school.dashboard',
      title: 'Kurumsal Okul & Sınıf Yönetim Paneli',
      desc: 'Tüm okul sınıflarını tek merkezden yönetme ve toplu öğrenci ekleme.',
      highlight: true,
    },
    {
      id: 'teacher.panel',
      title: 'Öğretmenler İçin Ödev & Quiz Atama',
      desc: 'Müfredata uygun haftalık ödevler tanımlama ve teslimleri takip etme.',
    },
    {
      id: 'report.pdf',
      title: 'Kazanım Analiz Raporları (PDF/Excel)',
      desc: 'Sınıf ve okul bazında detaylı başarı grafiklerini tek tıkla raporlama.',
    },
    {
      id: 'unlimited.accounts',
      title: 'Toplu Öğrenci & Öğretmen Lisansı',
      desc: 'Okulunuzun öğrenci kapasitesine göre ölçeklenen kurumsal lisans.',
    },
  ],
};

// Bir plan nesnesini analiz ederek kullanıcı odaklı zengin özellik listesi döndürür
export function getPlanFeatures(plan: any): PlanFeatureItem[] {
  if (!plan) return [];

  const tier = (plan.tier || '').toLowerCase();
  const type = (plan.type || '').toLowerCase();
  const name = (plan.name || '').toLowerCase();

  // Tier tespiti
  let category = 'pro';
  if (tier === 'parent' || tier === 'veli' || type === 'parent' || name.includes('veli')) {
    category = 'parent';
  } else if (tier === 'school' || type === 'school' || tier.includes('okul') || name.includes('okul')) {
    category = 'school';
  } else if (tier === 'premium' || name.includes('premium')) {
    category = 'premium';
  } else if (tier === 'free' || name.includes('ücretsiz') || name.includes('free') || plan.price_try === 0) {
    category = 'free';
  } else {
    category = 'pro';
  }

  const rawFeatures: string[] = Array.isArray(plan.features) ? plan.features : [];

  // Eğer planın DB'de tanımlı özellikleri az veya yoksa (örn: Veli planında 0-1 özellik), zengin varsayılan seti döndür
  if (rawFeatures.length <= 1) {
    const defaultSet = DEFAULT_TIER_FEATURES[category] || DEFAULT_TIER_FEATURES.pro;
    return defaultSet;
  }

  // Aksi halde raw features'ı zengin katalogla eşleştir ve gerekirse açıklama ekle
  const result: PlanFeatureItem[] = [];
  const seenKeys = new Set<string>();

  // AI mesaj limiti ekleme (Veli planı hariç)
  if (category !== 'parent' && category !== 'school') {
    const maxAi = plan.max_ai_messages_per_day ?? plan.daily_ai_message_limit ?? plan.limits?.daily_ai_messages;
    if (maxAi === 10) {
      result.push({
        id: 'ai.chat',
        title: 'CinAli AI Öğretmen (Günde 10 Soru)',
        desc: 'Yapay zeka öğretmenine takıldığı yerlerde temel sorular sorup yardım alma hakkı.',
      });
      seenKeys.add('ai.chat');
      seenKeys.add('ai.chat_30');
      seenKeys.add('ai.mentor');
    } else if (maxAi && maxAi > 10 && maxAi < 100) {
      result.push({
        id: 'ai.chat_30',
        title: `CinAli AI Desteği (Günde ${maxAi} Soru)`,
        desc: 'Takıldığı sorularda anında ipucu veren ve adım adım yönlendiren akıllı mentorluk.',
        highlight: true,
      });
      seenKeys.add('ai.chat');
      seenKeys.add('ai.chat_30');
      seenKeys.add('ai.mentor');
    } else if (maxAi === null || maxAi === undefined || maxAi >= 100) {
      result.push({
        id: 'ai.mentor',
        title: 'Sınırsız CinAli YZ Mentorluk',
        desc: '7/24 kesintisiz soru sorma, anında açıklama ve adım adım kod kılavuzluğu.',
        highlight: true,
      });
      seenKeys.add('ai.chat');
      seenKeys.add('ai.chat_30');
      seenKeys.add('ai.mentor');
    }
  }

  for (const rawKey of rawFeatures) {
    const normalized = normalizeKey(rawKey);

    // AI limit daha önce eklendiyse mükerrer ekleme
    if (seenKeys.has(normalized)) continue;
    if ((normalized.includes('ai.mentor') || normalized.includes('ai.chat')) && seenKeys.has('ai.mentor')) continue;

    seenKeys.add(normalized);

    const match = FEATURE_CATALOG[normalized];
    if (match) {
      result.push({
        id: normalized,
        title: match.title,
        desc: match.desc,
      });
    } else {
      // Bilinmeyen bir anahtar ise kullanıcı dostu formata dönüştür
      const prettyTitle = rawKey
        .replace(/[._]/g, ' ')
        .split(' ')
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
      result.push({
        id: rawKey,
        title: prettyTitle,
      });
    }
  }

  // Eğer eşleşme sonrası liste yetersiz kaldıysa varsayılan özelliklerle takviye et
  if (result.length < 3) {
    const fallbackList = DEFAULT_TIER_FEATURES[category] || DEFAULT_TIER_FEATURES.pro;
    for (const item of fallbackList) {
      if (!result.some(r => r.id === item.id || r.title === item.title)) {
        result.push(item);
      }
    }
  }

  return result;
}
